import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ProcessAsyncRecordStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import AutomatedMappingIssuesTableModal from 'processes/modals/AutomatedMappingIssuesTableModal';
import Tooltip from 'ui-library/bs/Tooltip';
import {RED} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import runModal from 'ui-library/runModal';
import PreventParentClickWrapper from 'ui-library/wrappers/PreventParentClickWrapper';

import {ProcessTaskListingGraphQL as ProcessTaskListing} from '../../../graphql-fragments/processes/__generated/ProcessTaskListingGraphQL';

interface ProcessTaskCellTitleProps {
  processTask: ProcessTaskListing;
  title: string;
}

export default function ProcessTaskCellTitle(props: ProcessTaskCellTitleProps): JSX.Element {
  const failedProcessAsyncRecords = props.processTask.processAsyncRecords.filter(
    ({status}) => status === ProcessAsyncRecordStatus.FAILED
  );
  return (
    <>
      {failedProcessAsyncRecords.length > 0 && (
        <span className={css(styles.iconWrapper)}>
          <Tooltip title="Fix mapping issues to continue flowchart">
            <PreventParentClickWrapper>
              <BenchlingIcon
                icon="revision"
                color={RED}
                onClick={async (e) => {
                  await runModal(AutomatedMappingIssuesTableModal, {
                    processAsyncRecordIds: failedProcessAsyncRecords.map(
                      (processAsyncRecord) => processAsyncRecord.id
                    ),
                  });
                }}
              />
            </PreventParentClickWrapper>
          </Tooltip>
        </span>
      )}
      <span key="name" className="sidepanel-primaryLabel">
        {props.title}
      </span>
    </>
  );
}

const styles = StyleSheet.create({
  iconWrapper: {
    marginRight: '5px',
  },
});
